import { render } from "./DeletePrintingProfile.vue?vue&type=template&id=19bc33cb"
import script from "./DeletePrintingProfile.vue?vue&type=script&lang=js"
export * from "./DeletePrintingProfile.vue?vue&type=script&lang=js"

import "./DeletePrintingProfile.vue?vue&type=style&index=0&id=19bc33cb&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__